export default "__VITE_ASSET__43928c54__"